export enum UserBankAccountStatus {
  New = 1,
  MatchingCardNumberWithKyc = 10,
  CardNumberWithKycMatched = 11,
  ExtractingCardNumberInfo = 12,
  Verified = 20,
  Rejected = 21,
}
